import { useQuery } from '@tanstack/react-query';
import type IAnticipation from 'interfaces/IAnticipation';
import financialService from 'v2/services/financial';

export const useListInvoiceAntecipation = () => {
  const { data, isFetching, error, refetch } = useQuery({
    queryKey: ['financial', 'invoices', 'anticipation'],
    queryFn: () => financialService.listAnticipation().toPromise()
  });

  return {
    data: {
      invoices: (data?.invoices as IAnticipation[]) ?? [],
      availableAnticipation: data?.availableAnticipation ?? 0,
      availableTransfer: data?.availableTransfer ?? 0
    },
    isFetching,
    error,
    refetch
  };
};
